import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { UserPlus, AlertCircle } from 'lucide-react';

export const Register = () => {
  const [formData, setFormData] = useState({ name: '', email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const next = searchParams.get('next');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    const result = await register(formData.email, formData.password, formData.name);
    if (result.success) navigate(next || '/dashboard');
    else setError(result.error);
    setLoading(false);
  };

  return (
    <div className="min-h-[calc(100vh-80px)] flex items-center justify-center px-4 sm:px-6 lg:px-8 hero-gradient" data-testid="register-page">
      <div className="max-w-md w-full">
        <div className="card-surface p-8 sm:p-10">
          <div className="text-center mb-8">
            <h2 className="text-3xl sm:text-4xl font-bold mb-2 text-strong" data-testid="register-heading">Create Account</h2>
            <p className="text-sm text-muted" data-testid="register-description">Get started with your widget collection</p>
          </div>

          {error && (
            <div className="mb-6 p-4 rounded-lg border border-red-500/30 bg-red-500/5 flex items-center space-x-2" data-testid="register-error-message">
              <AlertCircle className="w-5 h-5 text-red-400" />
              <span className="text-red-400 text-sm">{error}</span>
            </div>
          )}

          <form onSubmit={handleSubmit} data-testid="register-form">
            <div className="space-y-5">
              <div>
                <label htmlFor="name" className="block text-sm font-medium text-default mb-2">Full Name</label>
                <input type="text" id="name" value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} required
                  className="w-full input-field px-4 py-3 text-sm" data-testid="register-name-input" />
              </div>

              <div>
                <label htmlFor="email" className="block text-sm font-medium text-default mb-2">Email</label>
                <input type="email" id="email" value={formData.email} onChange={(e) => setFormData({ ...formData, email: e.target.value })} required
                  className="w-full input-field px-4 py-3 text-sm" data-testid="register-email-input" />
              </div>

              <div>
                <label htmlFor="password" className="block text-sm font-medium text-default mb-2">Password</label>
                <input type="password" id="password" value={formData.password} onChange={(e) => setFormData({ ...formData, password: e.target.value })} required minLength={6}
                  className="w-full input-field px-4 py-3 text-sm" data-testid="register-password-input" />
              </div>

              <button type="submit" disabled={loading}
                className="w-full btn-primary px-6 py-3.5 inline-flex items-center justify-center space-x-2 disabled:opacity-60 disabled:cursor-not-allowed"
                data-testid="register-submit-button">
                <UserPlus className="w-4 h-4" />
                <span>{loading ? 'Creating account...' : 'Create Account'}</span>
              </button>
            </div>
          </form>

          <div className="mt-6 text-center">
            <p className="text-sm text-muted">
              Already have an account?{' '}
              <Link to="/login" className="brand-green font-semibold hover:opacity-90" style={{ color: '#39FF14' }} data-testid="register-login-link">
                Sign in
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
